export enum StatusActionTypes {
  FETCH_STATUS_REQUEST = "FETCH_STATUS_REQUEST",
  FETCH_STATUS_SUCCESS = "FETCH_STATUS_SUCCESS",
  FETCH_STATUS_FAILURE = "FETCH_STATUS_FAILURE",
}

// Action interfaces
export interface FetchStatusRequestAction {
  type: StatusActionTypes.FETCH_STATUS_REQUEST;
}

export interface FetchStatusSuccessAction {
  type: StatusActionTypes.FETCH_STATUS_SUCCESS;
  payload: any;
}

export interface FetchStatusFailureAction {
  type: StatusActionTypes.FETCH_STATUS_FAILURE;
  payload: string;
}

// Action creators
export const fetchStatusRequest = (): FetchStatusRequestAction => ({
  type: StatusActionTypes.FETCH_STATUS_REQUEST,
});

export const fetchStatusSuccess = (data: any): FetchStatusSuccessAction => ({
  type: StatusActionTypes.FETCH_STATUS_SUCCESS,
  payload: data,
});

export const fetchStatusFailure = (
  error: string
): FetchStatusFailureAction => ({
  type: StatusActionTypes.FETCH_STATUS_FAILURE,
  payload: error,
});

export type StatusActions =
  | FetchStatusRequestAction
  | FetchStatusSuccessAction
  | FetchStatusFailureAction;
